import { inject } from "mobx-react";
import * as React from "react";
import { RouteStore } from "bernie-core";
import { UitkLink } from "uitk-react-link";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
import { useLocalization } from "@shared-ui/localization-context";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkCard, UitkCardContent } from "uitk-react-cards";

const authUrlGenerator = (url: string) => (routeStore?: RouteStore): string => {
  const pathname = routeStore?.pathname || "";
  const queries = routeStore?.search || "";

  const currentUrl = pathname + queries;

  return url + currentUrl;
};

interface LoyaltySignupProps {
  context?: ExtendedContextStore;
  routeStore?: RouteStore;
  classNames?: string;
  variant?: number;
}

export const LoyaltySignup: React.FC<LoyaltySignupProps> = inject(
  "context",
  "routeStore"
)((props: LoyaltySignupProps) => {
  const { classNames = "", context, variant, routeStore } = props;
  const isAuth = context && context.user && context.user.state !== "anonymous";
  const isVariantActive =
    context && isVariantEnabled(context, Experiment.Flex_HTG_Blossom_Loyalty_signin_signup, variant);

  const { formatText } = useLocalization();

  const loyaltySignupTitle = formatText("loyatlySignup.title");
  const loyaltySignupSubtitle = formatText("loyatlySignup.subtitle");
  const linkConfig = [
    {
      message: formatText("loyatlySignup.signUp"),
      trackedLinkRffr: "signUp",
      createGetUrl: authUrlGenerator("/user/createaccount?uurl=e3id=redr%26rurl%3D%2F"),
    },
    {
      message: formatText("loyatlySignup.singIn"),
      trackedLinkRffr: "signIn",
      createGetUrl: authUrlGenerator("/user/signin?uurl=e3id=redr%26rurl%3D%2F"),
    },
  ];

  if (isAuth || !isVariantActive) {
    return null;
  }

  return (
    <UitkCard className={`LoyaltySignup ${classNames}`}>
      <UitkCardContent>
        <UitkLayoutFlex justifyContent="space-between" alignItems="center">
          <UitkLayoutFlexItem>
            <UitkMark
              name="mod_exp"
              size={UitkMarkSize.LARGE}
              className="all-l-margin-four all-r-margin-one all-y-margin-four"
            />
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem grow={1}>
            <div className="all-x-padding-three all-y-padding-three">
              {loyaltySignupTitle && (
                <UitkHeading level={3} size={300}>
                  {loyaltySignupTitle}
                </UitkHeading>
              )}
              {loyaltySignupSubtitle && <UitkText size={300}>{loyaltySignupSubtitle}</UitkText>}
              <div className="all-t-margin-two">
                {linkConfig.map(({ createGetUrl, ...linkProps }) => {
                  return <AuthLink key={linkProps.trackedLinkRffr} href={createGetUrl(routeStore)} {...linkProps} />;
                })}
              </div>
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkCardContent>
    </UitkCard>
  );
});

interface AuthLinkProps {
  message: string;
  trackedLinkRffr: string;
  href: string;
}

const AuthLink: React.FC<AuthLinkProps> = (props) => {
  const { trackedLinkRffr, message, href } = props;

  return (
    <UitkLink inline={true} className="all-r-margin-six">
      <TrackedLink
        href={href}
        moduleName="Hotels"
        linkName={trackedLinkRffr}
        rfrr={`loyaltySignup.actionLink.${trackedLinkRffr}`}
      >
        {message}
      </TrackedLink>
    </UitkLink>
  );
};

export default LoyaltySignup;
